import {HIDE_REQUESTED_NOTIFICATION, REMOVE_NOTIFICATION, SET_NOTIFICATIONS} from "../actions/actionTypes";

const initialState = {
  notifications: [],
  requestToChange: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload.notifications,
        requestToChange: action.payload.requestToChange,
      };
    case REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.id !== action.payload)
      };
    case HIDE_REQUESTED_NOTIFICATION:
      return {
        ...state,
        requestToChange: state.requestToChange.filter(notification => notification.id !== action.payload)
      };
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/notification.js